export interface Permission {
    _id?: string;
    userId: number;
    userEmail: string;
    module: string;
    level: 'read' | 'write';
    createdAt?: Date;
    updatedAt?: Date;
}

/** API permission item: object with _id, module and level */
export interface UserPermissionItem {
    _id: string;
    module?: string;
    level?: 'read' | 'write';
}

/** API response: one record per user with nested permissions array */
export interface UserPermissionsResponse {
    _id: string;
    userId: number;
    userEmail: string;
    createdAt: string;
    updatedAt: string;
    __v?: number;
    permissions: UserPermissionItem[];
}

/** Converts one API permission item to a flat Permission or null if missing module/level. */
export function permissionItemToFlat(item: UserPermissionItem, userId: number, userEmail: string): Permission | null {
    if (item.module && (item.level === 'read' || item.level === 'write')) {
        return { _id: item._id, userId, userEmail, module: item.module, level: item.level };
    }
    return null;
}

/** Converts full API response to flat Permission[] for use in guards/nav/dashboard */
export function userPermissionsResponseToFlat(res: UserPermissionsResponse): Permission[] {
    if (!res?.permissions?.length) return [];
    return res.permissions
        .map(p => permissionItemToFlat(p, res.userId, res.userEmail))
        .filter((p): p is Permission => p !== null);
}

export interface CreatePermissionRequest {
    userId: number;
    userEmail: string;
    module: string;
    level: 'read' | 'write';
}

export interface UpdatePermissionRequest {
    module?: string;
    level?: 'read' | 'write';
}

export interface PermissionCheckResponse {
    hasAccess: boolean;
    level: string | null;
}
